import { useRef } from 'react'
import Tabs from '@/components/Tabs'
import { Outlet, useLocation, useSearchParams } from 'react-router-dom'

import NotesDrawer from './NotesDrawer'
import { hasRoiUrlParams } from './roi-url-params'
import {
  hydrateRoiStoresFromSearchParams,
  useRoiUrlSync,
} from './use-roi-url-sync'

const TabItems = [
  { name: 'Home', to: '', end: true },
  { name: 'Product contrast', to: 'pc' },
  { name: 'Country contrast', to: 'cc' },
  { name: 'Weekly', to: 'weekly' },
  { name: 'Weekly doc', to: 'weekdoc' },
  { name: 'Monthly', to: 'monthly' },
  { name: 'JP Group', to: 'jpgroup' },
  { name: 'Apple regression', to: 'apple/regression' },
]

function Index() {
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()
  const hydrated = useRef(false)

  if (!hydrated.current) {
    if (hasRoiUrlParams(searchParams)) {
      hydrateRoiStoresFromSearchParams(searchParams, pathname)
    }
    hydrated.current = true
  }

  useRoiUrlSync()

  return (
    <div className="flex flex-col">
      <Tabs datas={TabItems} preserveSearch />
      <Outlet />
      <NotesDrawer />
    </div>
  )
}

export default Index
